export default "__VITE_ASSET__BzLdI8PV__"